






import {Component, Prop, Vue} from "vue-property-decorator";
import {UnitSystem} from "@/interfaces/units";
import {lccaStore} from "@/store/store";
import CriticalLocationDepthInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationDepthInspector.vue";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";
import * as THREE from "three";
import {WEBGL} from "three/examples/jsm/WebGL";
import tinygradient from "tinygradient";
import {IPrMonteCarloDrawImperial} from "@/modules/perRoad/interfaces/monteCarlo";
import {WireframeGeometry2} from "three/examples/jsm/lines/WireframeGeometry2";

const MeshLine = require("three.meshline").MeshLine;
const MeshLineMaterial = require("three.meshline").MeshLineMaterial;
const MeshLineRaycast = require("three.meshline").MeshLineRaycast;

@Component({
  components: {
    CriticalLocationLayoutInspector,
    CriticalLocationDepthInspector,
  },
})
export default class InspectorThreeJS extends Vue {

  @Prop() draw!: IPrMonteCarloDrawImperial;

  plotKey = 0;

  viewHeight = 400;
  viewWidth = 1000;
  // viewWidth = document.getElementById('threejs-container-container').clientWidth;

  vh = `${this.viewHeight}px`;
  // vw = `${this.viewWidth}px`;

  laneWidth_in = 80;
  laneLength_in = 1200;


  get displayLayers() {
    return this.draw.layers.map((layer, i) => {
      return {
        id: layer.id,
        number: layer.layerNumber,
        parameters: layer,
        criticalLocations: this.draw.wesleaConfig ? this.draw.wesleaConfig.criticallocations.filter(cr => cr.l === (i + 1)) : [],
        //@ts-ignore
        wesleaResults: this.draw.wesleaResult.filter((cr, j) => this.draw.wesleaConfig.criticallocations[j] ? this.draw.wesleaConfig.criticallocations[j].l === (i + 1) : false)
      };
    });
  }

  display() {

    const el = document.getElementById("threejs-container");
    if (el === null) {
      return null;
    }

    /**
     * Setup
     */

    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0xFFFFFF);

    const animate = () => {
      const id = requestAnimationFrame(animate);
      renderer.render(scene, isoCamera);
      // cancelAnimationFrame(id);
    };

    const camera = new THREE.PerspectiveCamera(10, this.viewWidth / this.viewHeight, 0.1, 1000);
    camera.position.z = 150;
    camera.position.y = 40;
    camera.position.x = -140;
    camera.lookAt(0, -10, 10);

    const aspect = this.viewWidth / this.viewHeight;
    const d = 20;

    const isoCamera = new THREE.OrthographicCamera(-d * aspect, d * aspect, d, -d, 1, 1000);
    const isoPos = 120;
    isoCamera.position.set(-isoPos, 20, isoPos);
    isoCamera.lookAt(0, -5, 10);

    const renderer = new THREE.WebGLRenderer();
    renderer.setSize(el.clientWidth, el.clientHeight);
    renderer.setPixelRatio(window.devicePixelRatio);
    el.appendChild(renderer.domElement);

    const axesHelper = new THREE.AxesHelper(50);
    scene.add(axesHelper);

    /**
     * Lights
     */

        // const ambientLight = new THREE.AmbientLight();
        // ambientLight.intensity = .5;
        // scene.add(ambientLight);

    const directionalLight = new THREE.DirectionalLight(0xffffff);
    directionalLight.intensity = 1;
    directionalLight.position.set(-100, 180, 10);
    directionalLight.castShadow = true;
    scene.add(directionalLight);

    /**
     * Testing
     */

    function basicBox() {
      const g = new THREE.BoxGeometry(40, 5, 120);
      const m = new THREE.MeshLambertMaterial({color: 0xFF0000, opacity: 0.5});
      const box = new THREE.Mesh(g, m);
      g.applyMatrix4(new THREE.Matrix4().makeTranslation(0, 0, -60));
      scene.add(box);
    }

    // basicBox()

    /**
     * Create layer geometries and add them to the scene
     */
    this.displayLayers.forEach(layer => {

      // Gradient by log of modulus
      const gradientMinPos = 0;
      const gradientMaxPos = Math.log(15000000);
      const gradient = tinygradient([
        {color: "#FFFFFF", pos: 0},
        {color: "#333333", pos: 1}
      ]);
      const fillColor = gradient.rgbAt(Math.log(layer.parameters.modulus_psi) / gradientMaxPos);

      // If it's the bottom layer, depth is like 999" -> Shouldn't matter?
      let thickness_in = layer.parameters.depthOfLayerBottom_in - layer.parameters.depthOfLayerTop_in;

      // Create layer geometry
      const geometry = new THREE.BoxGeometry(this.laneLength_in, thickness_in, this.laneWidth_in);

      //Move to location within pavement
      geometry.applyMatrix4(new THREE.Matrix4().makeTranslation(
          (this.laneLength_in / 2),
          -layer.parameters.depthOfLayerTop_in - 0.5 * thickness_in,
          0,
      ));

      const material = new THREE.MeshLambertMaterial({
        transparent: true,
        opacity: 0.8
      });
      material.color = new THREE.Color(fillColor.toRgbString());
      const layerRect = new THREE.Mesh(geometry, material);
      scene.add(layerRect);


      const edges = new WireframeGeometry2(geometry);

      // const lineGeo = new LineGeometry();
      // lineGeo.setPositions([0, 0, 0, 10, 10, 10]);
      // lineGeo.setColors([0xFF0000, 0x00FF00]);

      // const lineSegments = new Wireframe(
      //     edges,
      //     new LineMaterial({
      //       linewidth: 3,
      //       dashed: false,
      //       color: 0xFF0000,
      //     }));
      // lineSegments.computeLineDistances();
      // lineSegments.scale.set(1, 1, 1);
      // scene.add(lineSegments);

      // const edgeGeometry = new LineGeometry();
      // console.log('position', geometry.getAttribute('position'));
      // const edgeVectors = [];
      // const vector = new THREE.Vector3();
      // const position = geometry.getAttribute('position');
      // for (let i = 0, j = position.count; i < j; i++) {
      //   vector.fromBufferAttribute(position, i);
      //   console.log(vector);
      //   edgeVectors.push(vector);
      // }
      // edgeGeometry.setPositions(edgeVectors);
      // edgeGeometry.attributes
      //
      // // edgeGeometry.setPositions(geometry.attributes.position);
      // const edgeMaterial = new LineMaterial({
      //   color: 0x000000,
      //   linewidth: 5
      // })
      // const edges = new Line2(edgeGeometry, edgeMaterial);
      // edges.computeLineDistances();
      // edges.scale.set(1, 1, 1);
      // scene.add(edges);

      const edgesEdgeGeo = new THREE.EdgesGeometry(geometry);
      const line = new THREE.LineSegments(edgesEdgeGeo, new THREE.LineBasicMaterial({
        color: 0x000000,
        linewidth: 5
      }));
      scene.add(line);

    });

    /**
     * Create points for critical locations
     */


    const allCrPoints: number[] = [];
    this.displayLayers.forEach(layer => {
      const crGeometry = new THREE.BufferGeometry();
      const vertices: number[] = [];
      layer.criticalLocations.forEach(cr => {
        // console.log(cr);
        vertices.push(cr.y, -cr.z, cr.x);
        if (cr.z < 100) {
          allCrPoints.push(cr.y, -cr.z, cr.x);
        }
      });

      crGeometry.setAttribute("position", new THREE.Float32BufferAttribute(vertices, 3));

      const crMaterial = new THREE.PointsMaterial({
        color: 0xFF0000,
        size: 10
      });
      const points = new THREE.Points(crGeometry, crMaterial);

      scene.add(points);
    });


    // Aim camera at critical locations
    const allPointsGeo = new THREE.BufferGeometry();
    allPointsGeo.setAttribute("position", new THREE.Float32BufferAttribute(allCrPoints, 3));
    allPointsGeo.computeBoundingSphere();
    camera.lookAt(allPointsGeo.boundingSphere ? allPointsGeo.boundingSphere.center : 0);
    isoCamera.lookAt(allPointsGeo.boundingSphere ? allPointsGeo.boundingSphere.center : 0);

    animate();
  }

  updatePlotKey() {
    this.plotKey += 1;
  }

  sync() {
    this.updatePlotKey();
    this.$emit("sync");
  }

  unitSystemIsImperial() {
    return lccaStore.displayUnits === UnitSystem.Imperial;
  }


  mounted() {
    if (WEBGL.isWebGLAvailable()) {

      // Initiate function or other initializations here
      this.display();

    } else {

      const warning = WEBGL.getWebGLErrorMessage();
      console.log(warning);
      //@ts-ignore possibly null
      document.getElementById("threejs-container").appendChild(warning);

    }
  }

}
